<button class="cart-action-button-clear btn-icon text-b3-s-300 color-black" (click)="onOpenClearModal()">
  <sd-icon [type]="iconTypes.DELETE" class="icon-size-m icon-size-lg-s"></sd-icon>
  @if (!isTabletMdDown()) {
    удалить
  }
</button>
